import { render, staticRenderFns } from "./VolunteerUpdateStatusCpt.vue?vue&type=template&id=6358081e&scoped=true&"
import script from "./VolunteerUpdateStatusCpt.vue?vue&type=script&lang=ts&"
export * from "./VolunteerUpdateStatusCpt.vue?vue&type=script&lang=ts&"
import style0 from "./VolunteerUpdateStatusCpt.vue?vue&type=style&index=0&id=6358081e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6358081e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VContainer,VDivider})
